export function documentationUrl(locale, path = '') {
  return `/docs/${locale === 'en' ? 'en/' : ''}${path.replace(/^\//, '')}`;
}
